export interface ReportDraft { markdown: string; activeSessionKey: string }
type DraftStorage = Pick<Storage, 'getItem' | 'setItem'>;

export function reportDraftKey(subject: string, vin: string, type: string): string | null {
  return subject ? `report-draft-v2:${JSON.stringify([subject, vin, type])}` : null;
}

function validDraft(value: unknown): value is ReportDraft {
  if (!value || typeof value !== 'object') return false;
  const draft = value as Partial<ReportDraft>;
  return typeof draft.markdown === 'string' && draft.markdown.length > 0 && draft.markdown.length <= 100000
    && typeof draft.activeSessionKey === 'string'
    && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(draft.activeSessionKey)
    && draft.activeSessionKey !== '00000000-0000-0000-0000-000000000000';
}

export function readReportDraft(storage: DraftStorage, subject: string, vin: string, type: string, requestedSession?: string): ReportDraft | null {
  const key = reportDraftKey(subject, vin, type);
  if (!key) return null;
  try {
    const raw = storage.getItem(key);
    if (!raw) return null;
    const value = JSON.parse(raw);
    return value?.subject === subject && validDraft(value)
      && (!requestedSession || value.activeSessionKey.toLowerCase() === requestedSession.toLowerCase())
      ? { markdown: value.markdown, activeSessionKey: value.activeSessionKey } : null;
  } catch { return null; }
}

export function writeReportDraft(storage: DraftStorage, subject: string, vin: string, type: string, draft: ReportDraft): void {
  const key = reportDraftKey(subject, vin, type);
  if (!key || !validDraft(draft)) return;
  try { storage.setItem(key, JSON.stringify({ subject, ...draft })); } catch { /* A full/blocked local store never changes ownership. */ }
}
